import request from "./../utils/request";

export function createComment(commentData) {
    return request({
        url: "/comments/create",
        method: "post",

        data: commentData,
    });
}

export function listComments(type, id) {
    return request({
        url: "/comments",
        method: "get",

        params: {
            type: type,
            id: id,
        },
    });
}

export function deleteComment(id) {
    return request({
        url: "/comments/delete",
        method: "delete",

        params: {
            id: id,
        },
    });
}

export function updateComment(id, newMessage) {
    return request({
        url: `/comments/${id}`,
        method: "put",

        data: {
            newMessage: newMessage,
            edited: true
        },
    });
}
